import { engagementLocationsApps } from "../engagementLocationsApps";
import type { AllRouteEndpoints } from "../routeTypes";
export const engagementEditLocationsAppsCacheKeys: AllRouteEndpoints[] = [engagementLocationsApps];
